module.exports = __webpack_public_path__ + "static/media/back8.1086fa53.jpg";